import require from '@/utils/request'
import { Login,
  ChangePwd,
  Register,
  QueryPage } from '@/types/UserAdmin'
/**
 *用户管理
 *
 *  UserPage                分页查询
 *  FreezeUser              冻结用户(禁用)
 *  FreezeUnfreezeUserUser  解冻用户(启用)
 * RegisterUser             用户注册
 * LoginUser                用户登录
 * changePwd                修改密码
 *  */

export const UserPage = (data: QueryPage) =>
  require({
    url: '/sysUser/queryPage',
    method: 'post',
    data
  })

export const FreezeUser = (id: number) =>
  require({
    url: '/sysUser/freezeAccount/' + id,
    method: 'post'
  })

export const UnfreezeUser = (id: number) =>
  require({
    url: '/sysUser/unfreezeAccount/' + id,
    method: 'post'
  })

export const RegisterUser = (data: Register) =>
  require({
    url: '/sysUser/register',
    method: 'post',
    data
  })

export const LoginUser = (data: Login) =>
  require({
    url: '/sysUser/login',
    method: 'post',
    data
  })

export const changePwd = (data: ChangePwd) =>
  require({
    url: '/sysUser/changePassword',
    method: 'post',
    data
  })
